<template>
  <div>
    <custom-dialog width="580px" :showClose="true" title="打包发货" v-if="pickDialogObj.show" :visible="pickDialogObj.show"
      :close-on-press-escape="false" @close="close">
      <div class="content" slot="content">
        <el-input ref="scanRef" v-model="prescriptionId" placeholder="扫描配方单二维码" @input="scanPrescription"></el-input>
        <div class="content_main">
          <div class="main_info" v-if="currentOrder">
            <div class="info_patient" v-if="patientInfo && currentOrder">
              <div class="info_delivery_type" @click="printOrder(currentOrder.prescriptionId)">{{
                currentOrder.deliveryWay == 0 ? '自提' : '配送' }}</div>
              <div class="info_patient_item">
                <div class="info_patient_item_label">患者信息：</div>
                <div class="info_patient_item_value">{{ patientInfo.name }} {{ patientInfo.sexName }}
                  {{ patientInfo.age }}岁{{ patientInfo.month }}月 {{ patientInfo.phone }}</div>
              </div>
              <div class="info_patient_item">
                <div class="info_patient_item_label">配方单号：</div>
                <div class="info_patient_item_value">{{ currentOrder.prescriptionCode }}</div>
              </div>
              <div class="info_patient_item">
                <div class="info_patient_item_label">{{ currentOrder.deliveryWay == 0 ? '自提' : '快递' }}地址：</div>
                <div class="info_patient_item_value">
                  <span>{{ currentOrder.logisticsAddress }}</span>
                  <i class="el-icon-copy-document ml4 color949" @click="handleCopy(currentOrder.logisticsAddress)"></i>
                </div>
              </div>
              <div class="info_patient_item">
                <div class="info_patient_item_label">包裹包含：</div>
                <div class="info_patient_item_value">
                  <div v-for="(item, index) in formulaList" :key="item.prescriptionId">配方单{{ index + 1 }}({{
                    item.showContent }})</div>
                </div>
              </div>
            </div>
            <div class="info_status_warp" v-if="pickOrderObj">
              <div v-if="pickOrderObj.isSuccess">
                <div class="info_status">
                  <div class="info_status_label">下单成功！配方单状态为</div>
                  <div class="info_status_tag"
                    :style="{ color: computedStatusColor(currentOrder.status), background: computedStatusBg(currentOrder.status) }">
                    {{ computedDictText(currentOrder.status, statusList) }}</div>
                </div>
                <div class="info_status_delivery" v-if="currentOrder.deliveryWay == '1'">
                  <div>快递信息：</div>
                  <div v-if="currentOrder.companyName">{{ currentOrder.companyName }} {{ currentOrder.trackingNumber }}
                  </div>
                  <i v-if="currentOrder.companyName" class="el-icon-copy-document ml4 color949"
                    @click="handleCopy(currentOrder.trackingNumber)"></i>
                </div>
                <div class="info_status_delivery" v-if="currentOrder.deliveryWay == '1'">
                  <div>发货时间：</div>
                  <div v-if="currentOrder.deliveryTimeHour">{{ currentOrder.deliveryTimeHour }}:{{
                    currentOrder.deliveryTimeMinute == '0' ? '00' : currentOrder.deliveryTimeMinute }}</div>
                </div>
                <div class="info_status_date">{{ pickOrderObj.pushTime }}</div>
              </div>
              <div v-else>
                <div class="info_status">
                  <div class="info_status_label">下单失败，您可以<span class="info_status_again"
                      @click="againOrder">点击重试</span>或去快递平台下单</div>
                </div>
                <div class="info_status_delivery">
                  <div>失败原因：<span v-html="pickOrderObj.errorMsg"></span></div>
                </div>
                <div class="info_status_date">{{ pickOrderObj.pushTime }}</div>
              </div>
            </div>
            <div class="info_status_warp" v-if="!pickOrderObj && currentOrder.status > 7">
              <div class="info_status">
                <div class="info_status_label">配方单状态为</div>
                <div class="info_status_tag"
                  :style="{ color: computedStatusColor(currentOrder.status), background: computedStatusBg(currentOrder.status) }">
                  {{ computedDictText(currentOrder.status, statusList) }}</div>
              </div>
              <div class="info_status_delivery" v-if="currentOrder.deliveryWay == '1'">
                <div>快递信息：</div>
                <div v-if="currentOrder.companyName">{{ currentOrder.companyName }} {{ currentOrder.trackingNumber }}
                </div>
                <div v-else class="info_status_delivery_tips"><i class="el-icon-warning-outline ml8 size14"></i>
                  请完善快递信息！</div>
                <i v-if="currentOrder.companyName" class="el-icon-copy-document ml4 color949"
                  @click="handleCopy(currentOrder.trackingNumber)"></i>
              </div>
              <div class="info_status_delivery" v-if="currentOrder.deliveryWay == '1'">
                <div>发货时间：</div>
                <div v-if="currentOrder.deliveryTimeHour">{{ currentOrder.deliveryTimeHour }}:{{
                  currentOrder.deliveryTimeMinute == '0' ? '00' : currentOrder.deliveryTimeMinute }}</div>
              </div>
              <div class="info_status_date">{{ currentOrder.updateTime }}</div>
            </div>
            <!-- 2025-03-26 杨蕾要求先注释 -->
            <!-- <div class="info_btn" v-if="currentOrder.status == '10'" @click="editDelivery">修改快递信息</div> -->
          </div>
          <el-empty v-else :image="imgArr.formulaNoData" :image-size="80" description="请先扫描配方单二维码"></el-empty>
        </div>
      </div>
      <div slot="footer"></div>
    </custom-dialog>
    <!--  -->
    <custom-dialog width="500px" :showClose="true" title="请选择打包信息" v-if="orderDialogObj.show"
      :visible.sync="orderDialogObj.show" :close-on-press-escape="false" @close="orderDialogClose">
      <div class="order_content" slot="content" v-loading="orderDialogObj.loading">
        <div class="order_content_main">
          <div class="info_patient" v-if="currentOrder">
            <div class="info_delivery_type">{{ currentOrder.deliveryWay == 0 ? '自提' : '配送' }}</div>
            <div class="info_patient_item">
              <div class="info_patient_item_label">患者信息：</div>
              <div class="info_patient_item_value">{{ patientInfo.name }} {{ patientInfo.sexName }}
                {{ patientInfo.age }}岁{{ patientInfo.month }}月 {{ patientInfo.phone }}</div>
            </div>
            <div class="info_patient_item">
              <div class="info_patient_item_label">配方单号：</div>
              <div class="info_patient_item_value">{{ currentOrder.prescriptionCode }}</div>
            </div>
            <div class="info_patient_item">
              <div class="info_patient_item_label">{{ currentOrder.deliveryWay == 0 ? '自提' : '快递' }}地址：</div>
              <div class="info_patient_item_value">
                <span>{{ currentOrder.logisticsAddress }}</span>
                <i class="el-icon-copy-document ml4 color949" @click="handleCopy(currentOrder.logisticsAddress)"></i>
              </div>
            </div>
          </div>
          <div class="formula_warp" v-if="formulaList.length > 1">
            <div class="formula_warp_title">该患者有{{ formulaList.length }}个配方单可合并{{ currentOrder.deliveryWay == '1' ? '发货'
              : '打包' }}，请选择：</div>
            <el-checkbox-group v-model="checkList">
              <div class="formula_warp_item" v-for="(item, index) in formulaList" :key="item.prescriptionId">
                <el-checkbox :label="item.prescriptionId" :disabled="item.currentPrescriptionFlag">配方单{{ index + 1 }}({{
                  item.showContent }})</el-checkbox>
                <div class="formula_warp_item_status"
                  :style="{ color: computedStatusColor(item.status), background: computedStatusBg(item.status) }">{{
                    computedDictText(item.status, statusList) }}</div>
                <div class="formula_warp_item_tips" v-if="item.currentPrescriptionFlag">本单</div>
              </div>
            </el-checkbox-group>
          </div>
          <div class="delivery_company_warp" v-if="currentOrder.deliveryWay == 1">
            <div class="delivery_company_warp_title">请选择快递公司：</div>
            <div class="company_list">
              <div v-for="item in companyList" :key="item.id" class="company_list_item"
                :class="{ 'company_list_item_active': item.id === companyId }" @click="selectCompany(item.id)">
                <img v-if="item.companyIcon" :src="imgArr[item.companyIcon]" class="company_list_item_icon">
                <div>{{ item.companyName }}</div>
              </div>
              <!-- <div class="company_list_item" :class="{ 'company_list_item_active': companyId == '' }"
                @click="selectCompany('')">手动下单</div> -->
            </div>
          </div>
        </div>
        <div class="content_footer">
          <custom-button type="info" size="medium" @click="orderDialogClose">取消</custom-button>
          <custom-button type="primary" size="medium" @click="createdOrder">确定</custom-button>
        </div>
      </div>
      <div slot="footer"></div>
    </custom-dialog>
    <custom-dialog width="397px" :showClose="true" :title="editDialogObj.title" v-if="editDialogObj.show"
      :visible="editDialogObj.show" @close="editDialogClose">
      <div class="edit_content" slot="content" v-loading="editDialogObj.loading">
        <div class="edit_content_formula" v-if="formulaList.length > 1 && !isManualOrder">
          <div>运单包含{{ formulaList.length }}个配方单，请选择：</div>
          <el-checkbox-group v-model="editCheckList" v-for="(item, index) in formulaList" :key="item.prescriptionId">
            <div class="formula_warp_item">
              <el-checkbox :label="item.prescriptionId">配方单{{ index + 1 }}({{ item.showContent }})</el-checkbox>
              <div class="formula_warp_item_tips" v-if="item.currentPrescriptionFlag">本单</div>
            </div>
          </el-checkbox-group>
        </div>
        <el-form :model="deliverForm" :rules="rules" ref="deliverForm" label-width="100px" class="demo-deliverForm">
          <el-form-item label="快递公司：" prop="companyName">
            <el-select v-model="deliverForm.companyName" placeholder="请选择" class="width100">
              <el-option v-for="item in transportCompanyList" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="快递单号：" prop="deliveryNumber">
            <el-input v-model="deliverForm.deliveryNumber" placeholder="请填写"></el-input>
          </el-form-item>
          <el-form-item label="发货时间：" prop="transportTime">
            <el-select v-model="deliverForm.transportTime" placeholder="请选择" class="width100">
              <el-option v-for="(item, index) in transportTimeList" :key="index" :disabled="item.enableStatus !== 1"
                :label="(item.deliveryTimeHour || '') + ':' + (item.deliveryTimeMinute || '00')"
                :value="(item.deliveryTimeHour || '') + ':' + (item.deliveryTimeMinute || '00')"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="content_footer">
          <custom-button type="info" size="medium" @click="editDialogClose">取消</custom-button>
          <custom-button type="primary" size="medium" @click="editDeliveryConfirm">确定</custom-button>
        </div>
      </div>
      <div slot="footer"></div>
    </custom-dialog>
  </div>
</template>

<script>
import CustomDialog from "@/components/customDialog/CustomDialog";
import { imgArr } from '@/assets/images/img'
import { getMergeList, getLogisticsList, logisticsCreateOrder, updateCourierNumberBatch, printLogistics, logisticsLog } from '@/api/formula'
import { debounce, isNull, getQueryParams, dictText, isEmptyArray, isNullObj, copy } from "@/utils/validateBase";
import { getCompany } from "@/api/delivery"
import { formulaDTO } from '@/DTO/index'
export default {
  props: {
    pickDialogObj: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  components: { CustomDialog },
  computed: {
    computedDictText() {
      return function (value, list) {
        return dictText(value, list)
      }
    },
    computedStatusColor() {
      return function (val) {
        return isNullObj(this.statusList.find(item => { return item.value == val })) ? '' : this.statusList.find(item => { return item.value == val }).color || ''
      }
    },
    computedStatusBg() {
      return function (val) {
        return isNullObj(this.statusList.find(item => { return item.value == val })) ? '' : this.statusList.find(item => { return item.value == val }).background || ''
      }
    },
  },
  data() {
    return {
      imgArr: imgArr,
      prescriptionId: '',
      orderDialogObj: {
        show: false,
        loading: false,
        isOutermost: false,//是否是最外层窗口
      },
      editDialogObj: {
        title: '修改快递信息',
        show: false,
        loading: false,
        isOutermost: false,//是否是最外层窗口
      },
      checkList: [],
      editCheckList: [],
      companyList: [],
      patientInfo: null,
      formulaList: [],
      statusList: [
        { value: '1', label: '待收方', color: '#1890FF', background: '#E8F4FF' },
        { value: '2', label: '待配方', color: '#FE8F1F', background: '#FFF0E1' },
        { value: '3', label: '配方中', color: '#FE8F1F', background: '#FFF0E1' },
        { value: '4', label: '待复核', color: '#FE8F1F', background: '#FFF0E1' },
        { value: '5', label: '待加工', color: '#FE8F1F', background: '#FFF0E1' },
        { value: '5', label: '待加工', color: '#FE8F1F', background: '#FFF0E1' },
        { value: '6', label: '加工中', color: '#FE8F1F', background: '#FFF0E1' },
        { value: '7', label: '待打包', color: '#FE8F1F', background: '#FFF0E1' },
        { value: '8', label: '待配送', color: '#FE8F1F', background: '#FFF0E1' },
        { value: '9', label: '配送中', color: '#FE8F1F', background: '#FFF0E1' },
        { value: '10', label: '待提货', color: '#FE8F1F', background: '#FFF0E1' },
      ],
      currentOrder: null,
      companyId: '',
      isManualOrder: false,//是否手动下单
      rules: {
        companyName: [
          { required: true, message: '请选择快递公司', trigger: 'change' },
        ],
        deliveryNumber: [
          { required: true, message: '请输入快递单号', trigger: 'blur' },
        ],
      },
      deliverForm: {},
      transportCompanyList: [],
      transportTimeList: [],
      pickOrderObj: null,
      step: 2,//快递公司一排展示多少个
      currentStep: 1,
      logList: []
    }
  },
  created() {
    this.$nextTick(() => {
      this.$refs.scanRef.focus();
    })
  },
  mounted() {
    window.addEventListener('keyup', this.handleKeyUp);
  },
  methods: {
    handleKeyUp(event) {
      let flag = this.orderDialogObj.isOutermost
      let stepIndex = this.currentStep
      let step = this.step
      if (!flag) return;
      switch (event.key) {
        case 'ArrowUp':
          if (stepIndex > step) {
            stepIndex = stepIndex - step
          }
          this.currentStep = stepIndex
          this.companyId = this.companyList[stepIndex - 1].id
          break;
        case 'ArrowDown':
          let tempIndex = stepIndex + step
          if (tempIndex <= this.companyList.length) {
            stepIndex = tempIndex
          }
          this.currentStep = stepIndex
          this.companyId = this.companyList[stepIndex - 1].id
          break;
        case 'ArrowLeft':
          if (stepIndex > 1) {
            stepIndex = stepIndex - 1
          }
          this.currentStep = stepIndex
          this.companyId = this.companyList[stepIndex - 1].id
          break;
        case 'ArrowRight':
          if (stepIndex < this.companyList.length) {
            stepIndex = stepIndex + 1
          }
          this.currentStep = stepIndex
          this.companyId = this.companyList[stepIndex - 1].id
          break;
        case 'Enter':
          this.createdOrder()
      }
    },
    close() {
      this.$emit('close')
    },
    orderDialogClose() {
      this.orderDialogObj.show = false
      this.orderDialogObj.isOutermost = false
      this.init()
    },
    // 扫描二维码
    scanPrescription: debounce(async function (url) {
      this.init() //先清空数据
      if(isNull(url)) return;
      let params = getQueryParams(url)
      if(isNull(params) || isNull(params.id)) return;
      let { code, data } = await getMergeList({ prescriptionId: params.id })
      // let { code, data } = await getMergeList({ prescriptionId: url })
      if (code == 200 && !isNull(data)) {
        this.prescriptionId = ''
        this.currentOrder = data || null
        this.patientInfo = data.patientInfo || null
        this.formulaList = data.logisticsMergablePrescriptionLists || []
        if (data.status == '7' && !isEmptyArray(data.logisticsMergablePrescriptionLists)) {
          // 待打包
          this.checkList.push(data.prescriptionId)
          this.orderDialogObj.show = true
          this.orderDialogObj.isOutermost = true
          if (data.deliveryWay == '1') {
            this.getLogisticsList()
          }
        }
        this.logisticsLog(data.prescriptionId)
      }
    }, 1 * 1000),
    // 查询自动下单物流公司
    async getLogisticsList() {
      let { code, data } = await getLogisticsList()
      if (code == 200 && !isNull(data)) {
        this.companyList = data
        this.companyList.push({
          id: '',
          companyName: '手动下单',
          companyIcon: ''
        })
        this.companyId = this.$session.get('deptId') == 127 ? this.companyList[0].id : this.companyList[this.companyList.length - 1].id
      }
    },
    // 选择快递公司
    selectCompany(id) {
      this.companyId = id
    },
    editDialogClose() {
      this.editDialogObj.show = false
      this.editDialogObj.isOutermost = false
      this.orderDialogObj.isOutermost = true
      this.editCheckList = []
      this.deliverForm = {}
    },
    //物流下单
    createdOrder() {
      if (this.$session.get('deptId') != 127 && !isNull(this.companyId)) {
        return this.$message.error('分馆暂不支持自动下单')
      }
      this.orderDialogObj.loading = true
      if (this.currentOrder.deliveryWay == '0') {
        // 打包
        this.mergedPackaging()
      } else if (this.currentOrder.deliveryWay == '1') {
        // 发货
        this.combinedShipping()
      }
    },
    //合并打包
    async mergedPackaging() {
      let { code } = await logisticsCreateOrder({ prescriptionIds: this.checkList })
      if (code == 200) {
        this.getCurrentFormula()
      }
      this.orderDialogObj.loading = false
    },
    // 合并发货
    async combinedShipping() {
      if (isNull(this.companyId)) {
        // 手动下单
        this.isManualOrder = true
        this.getTransPortTimeList()
        await this.getCompanyList()
        this.deliverForm = {
          orderId: this.currentOrder.orderId,
          logisticsOrderType: '1',
          companyName: '',
          deliveryNumber: '',
          transportTime: ''
        }
        this.editCheckList = this.checkList
        this.editDialogObj.title = '填写快递信息'
        this.editDialogObj.show = true
        this.editDialogObj.isOutermost = true
        this.orderDialogObj.isOutermost = false
        this.orderDialogObj.loading = false
      } else {
        // 自动下单
        this.isManualOrder = false
        let { code, data } = await logisticsCreateOrder({ prescriptionIds: this.checkList, logisticsCompanyId: this.companyId })
        if (code == 200) {
          this.pickOrderObj = data
          if (data.isSuccess) {
            await this.printOrder(this.currentOrder.prescriptionId)
            this.orderDialogObj.loading = false
            await this.getCurrentFormula()
          } else {
            this.orderDialogObj.loading = false
            let list = []
            this.formulaList.forEach(v1 => {
              data.prescriptionIds.forEach(v2 => {
                if (v1.prescriptionId == v2) { list.push(v1) }
              })
            })
            this.formulaList = list
            this.orderDialogObj.show = false
            this.orderDialogObj.isOutermost = false
            this.logisticsLog(this.currentOrder.prescriptionId)
          }
        } else {
          this.orderDialogObj.loading = false
        }
      }
    },
    // 修改快递信息
    async editDelivery() {
      this.getTransPortTimeList()
      await this.getCompanyList()
      this.deliverForm = {
        logisticsOrderType: '2',
        orderId: this.currentOrder.orderId,
        companyName: this.currentOrder.companyName,
        deliveryNumber: this.currentOrder.trackingNumber,
        transportTime: ''
      }
      this.formulaList.forEach(v => {
        this.editCheckList.push(v.prescriptionId)
      })
      this.isManualOrder = false
      this.editDialogObj.title = '修改快递信息'
      this.editDialogObj.show = true
      this.editDialogObj.isOutermost = true
      this.orderDialogObj.isOutermost = false
    },
    // 获取物流公司
    async getCompanyList() {
      let { code, data } = await getCompany();
      if (code == 200) {
        this.transportCompanyList = data || []
      }
    },
    // 获取物流发货时间列表
    async getTransPortTimeList() {
      let { code, data } = await formulaDTO.getTransPortOrderTimeList()
      if (code === 200) {
        this.transportTimeList = data || []
      }
    },
    // 修改快递信息确认
    editDeliveryConfirm() {
      this.$refs.deliverForm.validate(async (valid) => {
        if (valid) {
          this.editDialogObj.loading = true
          let params = {
            ...this.deliverForm,
            prescriptionIds: this.editCheckList,
            companyCode: this.transportCompanyList.find(v => { return v.name == this.deliverForm.companyName }).companyCode || '',
            deliveryTimeHour: this.deliverForm.transportTime ? this.deliverForm.transportTime.split(':')[0] : '',  // 时
            deliveryTimeMinute: this.deliverForm.transportTime ? this.deliverForm.transportTime.split(':')[1] : '', // 分
            deliveryTimeSecond: '' // 秒
          }
          let { code } = await updateCourierNumberBatch(params)
          if (code == 200) {
            this.editDialogObj.loading = false
            this.editDialogObj.show = false
            this.editDialogObj.isOutermost = false
            if (this.isManualOrder) {
              this.orderDialogObj.show = false
              this.orderDialogObj.isOutermost = false
              this.$message.success('下单成功')
              this.getCurrentFormula()
            } else {
              this.$message.success('修改成功!')
              this.init()
            }
          } else {
            this.editDialogObj.loading = false
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });

    },
    //清空信息，回到初始状态
    init() {
      this.$refs.scanRef.focus();
      this.currentOrder = null
      this.patientInfo = null
      this.prescriptionId = ''
      this.deliverForm = {}
      this.checkList = []
      this.editCheckList = []
    },
    //查询当前配方单信息
    async getCurrentFormula() {
      let { code, data } = await getMergeList({ prescriptionId: this.currentOrder.prescriptionId })
      if (code == 200) {
        this.orderDialogObj.show = false
        this.orderDialogObj.isOutermost = false
        this.currentOrder = data
        this.patientInfo = data.patientInfo || null
        this.formulaList = data.logisticsMergablePrescriptionLists || []
        this.$nextTick(() => {
          this.$refs.scanRef.focus();
        })
        this.logisticsLog(data.prescriptionId)
      }
    },
    //重新下单
    async againOrder() {
      this.orderDialogObj.loading = true
      let { code, data } = await logisticsCreateOrder({ prescriptionIds: this.pickOrderObj.prescriptionIds, logisticsCompanyId: this.pickOrderObj.companyId })
      if (code == 200) {
        this.orderDialogObj.loading = false
        this.pickOrderObj = data
        if (data.isSuccess) {
          await this.printOrder(this.currentOrder.prescriptionId)
          await this.getCurrentFormula()
        }
      } else {
        this.orderDialogObj.loading = false
      }
    },
    handleCopy(val) {
      copy(val)
    },
    //打印快递单
    async printOrder(prescriptionId) {
      let { data } = await printLogistics({ prescriptionId })
      const blobUrl = URL.createObjectURL(data);
      // 3. 创建隐藏的iframe
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = blobUrl;
      document.body.appendChild(iframe);
      // 4. 打印处理
      iframe.onload = function () {
        setTimeout(() => {
          iframe.contentWindow.print();
        }, 500);
      };
      // 处理iframe加载错误
      iframe.onerror = function () {
        document.body.removeChild(iframe);
        URL.revokeObjectURL(blobUrl);
        throw new Error('PDF加载失败');
      };

      // frameWindow.onload = () => {
      //     setTimeout(() => {
      //       frameWindow.focus()
      //       frameWindow.print()
      //       document.body.removeChild(printFrame)
      //     }, 0)
      //   }
    },
    //查询打印日志
    async logisticsLog(prescriptionId) {
      let { code, data } = await logisticsLog({ prescriptionId })
      if (code == 200) {
        this.logList = data || []
      }
    },
  }
}
</script>

<style lang="less" scoped>
/deep/.dialog-content {
  padding: 0;
}

.content {
  padding: 20px;
  height: 472px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;
}

.content_main {
  flex: 1;
  overflow: auto;
  margin-top: 20px;
  padding-right: 2px;
}

.el-empty {
  margin-top: 100px;
}

.info_patient {
  padding: 12px;
  background: #F0F1F3;
  border-radius: 4px;
  position: relative;
}

.info_delivery_type {
  width: 48px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  background: #667182;
  border-radius: 0px 4px 0px 4px;
  position: absolute;
  top: 0;
  right: 0;
}

.info_patient_item {
  line-height: 20px;
  display: flex;
  font-weight: 400;
}

.info_patient_item_label {
  color: #667182;
  font-size: 14px;
  flex-shrink: 0;
}

.info_patient_item_value {
  color: #000;
  font-size: 14px;
}

.info_delivery_status_warp {
  margin-top: 16px;
}

.step_icon {
  color: #1890FF;
  font-size: 12px;
}

.info_status_warp {
  margin-top: 16px;
}

.info_status {
  display: flex;
  font-size: 14px;
  align-items: center;
}

.info_status_label {
  color: #303133;
  font-weight: 500;
}

.info_status_again {
  color: #1890FF;
  cursor: pointer;
}

.info_status_tag {
  width: 50px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  font-weight: 500;
  color: #1890FF;
  background: #E8F4FF;
  border-radius: 2px 2px 2px 2px;
  margin-left: 8px;
}

.info_status_delivery {
  color: #667182;
  font-size: 14px;
  margin-top: 4px;
  display: flex;
  align-items: center;
}

.info_status_delivery_tips {
  color: #FE8F1F;
}

.info_status_date {
  color: #A8ABB2;
  font-size: 13px;
  margin-top: 4px;
}

.info_btn {
  width: 108px;
  height: 32px;
  line-height: 32px;
  color: #1F2329;
  font-size: 14px;
  text-align: center;
  background: #FFFFFF;
  border-radius: 2px 2px 2px 2px;
  border: 1px solid #D3D3D5;
  margin-top: 24px;
  cursor: pointer;
}

.order_content {
  padding: 20px;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.order_content_main {
  padding-right: 4px;
  flex: 1;
  overflow: auto;
  margin-bottom: 20px;
}

.formula_warp {
  margin-top: 16px;
}

.formula_warp_title {
  padding-left: 4px;
  color: #000;
  font-size: 14px;
  font-weight: 500;
  border-left: 3px solid #1890FF;
}

.formula_warp_item {
  display: flex;
  margin-top: 16px;
}

.formula_warp_item_status {
  width: 50px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  font-weight: 500;
  font-size: 14px;
  color: #FE8F1F;
  background: #FFF0E1;
  border-radius: 2px 2px 2px 2px;
  margin-left: 8px;
}

.formula_warp_item_tips {
  width: 40px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  background: #29C01B;
  border-radius: 2px 2px 2px 2px;
  margin-left: 8px;
}

.delivery_company_warp {
  margin-top: 16px;
}

.delivery_company_warp_title {
  padding-left: 4px;
  color: #000;
  font-size: 14px;
  font-weight: 500;
  border-left: 3px solid #1890FF;
}

.company_list {
  margin-top: 16px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.company_list_item {
  height: 40px;
  color: #000000;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #D3D3D5;
  border-radius: 2px;
  box-sizing: border-box;
  cursor: pointer;
}

.company_list_item_active {
  background: #1890FF;
  color: #FFFFFF;
}

.company_list_item_icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  margin-right: 4px;
}

.edit_content {
  padding: 20px;
}

.edit_content_formula {
  padding-bottom: 16px;
  border-bottom: 1px dashed #D3D3D5;
  margin-bottom: 16px;
}

.content_footer {
  text-align: right;
}
</style>